module.exports = __webpack_public_path__ + "img/product6.2413f9f7.png";